import { render } from "./ViewAssetTemplate.vue?vue&type=template&id=f6a21578&scoped=true"
import script from "./ViewAssetTemplate.vue?vue&type=script&lang=js"
export * from "./ViewAssetTemplate.vue?vue&type=script&lang=js"

import "./ViewAssetTemplate.vue?vue&type=style&index=0&id=f6a21578&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f6a21578"]])

export default __exports__